// import objectMap from '@converdy/utils/object-map'
// import pipe from '@converdy/utils/pipe'

import splitBreakpoints from '../split-breakpoints'
import parseMargin from './parse-margin'
import parsePadding from './parse-padding'

function parseSpacing ({ margin = {}, padding = {} }) {
  return { ...parseMargin(margin), ...parsePadding(padding) }
}

// function parseSpacing ({
//   top,
//   right,
//   bottom,
//   left
// }) {
//   return pipe({ top, right, bottom, left })(
//     objectMap(
//       value => value,
//       (value, key) => {
//         const propertyName = value > 0 ? 'padding' : 'margin'
  
//         return `${propertyName}-${key}`
//       }
//     ),
//     objectMap(value => `${value}px`)
//   )
// }

export default splitBreakpoints(parseSpacing)
